import { CSSObject } from "@emotion/react";
import { constants, mediaQueryStyles } from "@newsela/angelou";

const { mediaQuery } = mediaQueryStyles;
const {
  BreakpointNames: { md },
} = constants.breakpoints;

export const rootCss: CSSObject = {
  whiteSpace: "nowrap",

  [mediaQuery.upTo(md)]: {
    padding: "3px",
  },
};

export const toastButtonCss = {
  textDecoration: "underline",
};
